import { jsx as _jsx } from "react/jsx-runtime";
import { useClientProgramLevels } from '@src/hooks/useClientProgramLevels';
import { useMyBenefits } from '@src/hooks/useMyBenefits';
import { createContext, useState } from 'react';
const DefaultProgramContext = {
    program: {},
    setProgram: () => { },
    paymentRequest: undefined,
    setPaymentRequest: () => { },
    benefitsLoading: false,
    getPolicy: () => undefined,
    refetch: () => { },
    clientProgramLevels: [],
    benefitProgramProps: undefined,
};
export const ProgramContext = createContext(DefaultProgramContext);
export const ProgramContextProvider = ({ program: initialProgram, paymentRequest: initialPaymentRequest, children, }) => {
    const [program, setProgram] = useState(initialProgram);
    const [paymentRequest, setPaymentRequest] = useState(initialPaymentRequest);
    const { myBenefits, loading: benefitsLoading, getPolicy, refetch, benefitProgramProps, } = useMyBenefits({ program, paymentRequest });
    const { clientProgramLevels } = useClientProgramLevels({
        clientId: program.clientId,
        isActive: true,
        // Use a large page size to ensure all active program levels are loaded for this dropdown.
        // If clients ever exceed this, consider implementing proper pagination in useClientProgramLevels.
        initialPageSize: 10000,
    });
    const value = {
        ...DefaultProgramContext,
        program,
        setProgram,
        paymentRequest,
        setPaymentRequest,
        myBenefits,
        benefitsLoading,
        getPolicy,
        refetch,
        clientProgramLevels,
        benefitProgramProps,
    };
    return _jsx(ProgramContext.Provider, { value: value, children: children });
};
